import { makeLabels } from 'utils/i18n';

const NAMESPACE = 'page.merchant.sections.kyb.components.modal.titanModal';
export const LABELS = makeLabels(
  {
    MODAL_TITLE: ['modalTitle', 'Bridge KYB'],
    CONTENT_TITLE: ['contentTitle', 'Merchant Data Available'],
    CONTENT_MESSAGE: [
      'contentMessage',
      'Titan data available, would you like to use it?<br/>THIS WILL OVERWRITE the existing data in the form',
    ],
    NO: ['no', 'No'],
    YES: ['yes', 'Yes'],
  },
  NAMESPACE,
);

export default LABELS;
